import React from 'react';
import fr from 'facet-rest';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { PreviewItem } from 'Components/ComponentLibrary/Components/Uncategorized/FileViewer/components/PreviewItem';
import {
  FDDialog, FDDialogActions, FDDialogContent, FDDialogTitle, FDSecondaryActionButton,
} from '@facet-wealth/design';
import useMobileLayout from 'Hooks/useMobileLayout';

export const IncomeSalaryPayStubDetailsAttachmentMobile = () => {
  const { resource } = useMetaLayoutContext();

  const [open, setOpen] = React.useState(false);

  const isMobile = useMobileLayout();

  if (!isMobile) {
    return null;
  }

  return resource.withRelationship(fr.relationships.attachment.name, (rel) => {
    return (
      <>
        <FDSecondaryActionButton
          label={'View uploaded pay stub'}
          onClick={() => setOpen(true)}
        />
        <FDDialog
          open={open}
          onClose={() => setOpen(false)}
          fullScreen
        >
          <FDDialogTitle />
          <FDDialogContent>
            <PreviewItem
              presentsAsDownloadable={resource.withRelationship(fr.relationships.presentsAsDownloadable.name, () => true, () => false)}
              attachmentName={rel.meta('title')}
              attachmentHref={rel.link('related').url()}
            />
          </FDDialogContent>
          <FDDialogActions>
            <FDSecondaryActionButton
              label={'Close'}
              onClick={() => setOpen(false)}
            />
          </FDDialogActions>
        </FDDialog>
      </>
    );
  }, () => null);
};
